import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const BottomLeftToPointToTopRightFill48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M14.7705 20.1855C15.161 19.5151 15.6531 18.9115 16.2236 18.3916L12.7636 15.209C11.925 14.369 12.5199 12.9328 13.705 12.9326L37.333 12.9326V10.667L14.6747 10.667C11.1095 10.667 9.32544 14.9738 11.8466 17.4951L14.7705 20.1855ZM21.333 29.334C24.2728 29.334 26.6668 26.9422 26.6669 24.001C26.6669 21.0596 24.273 18.667 21.333 18.667C18.3931 18.6672 15.9999 21.0598 15.9999 24.001C16.0001 26.9421 18.3932 29.3338 21.333 29.334ZM26.5664 37.334C30.129 37.334 31.9134 33.0259 29.3935 30.5059L27.3505 28.626C26.8785 29.238 26.3185 29.7783 25.6826 30.2236L28.4755 32.793C29.3169 33.633 28.7211 35.0684 27.5331 35.0684H21.333V37.334H26.5664Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
